import css from 'styled-jsx/css';

const styles = css.global`#open-finance-blog {
  background-color: #fbfbfb;
  padding-top: 32px;
  padding-bottom: 40px;
}

#open-finance-blog .is-desk {
  display: none;
}

#open-finance-blog .is-mobi {
  overflow: hidden;
}

#open-finance-blog .ctn-home-24 {
  position: relative;
}

#open-finance-blog .open-finance-blog-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin-bottom: 16px;
}

#open-finance-blog .open-finance-blog-slide {
  display: flex;
  justify-content: center;
  margin-right: 16px;
  margin-left: 0;
  flex: 0 0 272px;
}

#open-finance-blog .open-finance-blog-card {
  display: flex;
  flex-direction: column;
  color: #fff;
  width: 272px;
  min-height: 348px;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #CCC;
}

#open-finance-blog picture {
  width: 100%;
}

#open-finance-blog img {
  width: 100%;
  height: 189px;
  object-fit: cover;
  border-radius: 4px;
}

#open-finance-blog .open-finance-blog-card-textos {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 8px 16px 11px;
}

#open-finance-blog .open-finance-blog-slide-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  margin: 0;
}

#open-finance-blog .open-finance-blog-slide-link {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

#open-finance-blog .custom-carousel.embla {
  margin-bottom: 18px;
}


#open-finance-blog .home-pagination {
  width: 100%;
  max-width: 288px;
  margin-left: auto;
  margin-right: auto;
}

#open-finance-blog .home-pagination .enable-mobile-arrows {
  height: 24px;
  width: 24px;
  background-size: 24px 24px;
}

@media (min-width: 992px) {

  #open-finance-blog { 
    padding-top: 88px;
    padding-bottom: 88px;
  }

  #open-finance-blog .is-mobi {
    display: none;
  }

  #open-finance-blog .is-desk {
    display: flex;
    flex-direction: column;
    position: relative;
    margin: auto;
  }

  #open-finance-blog .cards-desk {
    display: flex;
    justify-content: space-between;
  }

  #open-finance-blog .open-finance-blog-card {
    width: 100%;
    max-width: 379px;
  }

  #open-finance-blog .open-finance-blog-card-textos {
    padding: 8px 16px 32px;
    /* height: 178px; */
  }

}`;

export default styles;